import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Row, Col } from "reactstrap"

import { Link } from "react-router-dom"

// components
import Applications from "pages/Dashboard/applications"

// services
import ApplicationService from "../../services/applications/Application.service"
import Staff from "services/staff/Staff"
import ApplicationFilter from "components/Filter/ApplicationFilter"

let appService = null
let plasticsUser = null
let staffService = new Staff()

const Assigned = () => {
  const [menu, setMenu] = useState(false)
  const [user, setuser] = useState()
  const [mounted, setmounted] = useState(false)
  const [permissions, setpermissions] = useState()
  const [assigned, setassigned] = useState()
  const [searchMode, setsearchMode] = useState(false)
  const [filterValues, setFilterValues] = useState({
    search: "",
    application_status: "",
    date_from: "",
    date_to: "",
    service_name: "",
  })

  const toggle = () => {
    setMenu(!menu)
  }

  useEffect(() => {
    const userObj = JSON.parse(localStorage.getItem("authUser"))
    appService = new ApplicationService(userObj)

    setuser(userObj)
    plasticsUser = appService.getStrategy("officer")
    plasticsUser.getAssignedTo(userObj.id, 1).then(response => {
      if (response.status) {
        // console.log("--->assigned", response)
        setassigned(response.data)
        setmounted(true)
      }
    })
  }, [])

  const paginate = page => {
    const userObj = JSON.parse(localStorage.getItem("authUser"))
    if (searchMode) {
      appService.searchApplications(filterValues, page).then(response => {
        setassigned(response.data)
      })
    } else {
      plasticsUser.getAssignedTo(userObj.id, page).then(response => {
        if (response.status) {
          setassigned(response.data)
        }
      })
    }
  }

  const initiateSearch = data => {
    data = {
      ...data,
      application_status:
        "SUBMITTED,REVIEWED,UNDER REVIEW,DEPARTMENT APPROVED,SENT_BACK_HoD,SENT_BACK_DG,RETURN TO APPLICANT,PROPOSE TO APPROVE,PROPOSE TO REJECT,PROPOSE TO RETURN BACK,DEPARTMENT_REJECTED,DG APPROVED",
    }
    setsearchMode(true)
    setFilterValues(data)
    appService.searchApplications(data, null).then(response => {
      if (response?.code && response.code == 200) {
        if (response.data.total == 0) {
          setassigned({ data: [] })
        } else {
          setassigned(response.data)
        }
      } else {
        setassigned({ data: [] })
      }
    })
  }

  const turnOffSearchMode = () => {
    setsearchMode(false)
    paginate(0)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Assigned | Staff</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Assigned</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    Applications assigned and reviewed by you will show up here.
                  </li>
                </ol>
              </Col>
            </Row>
          </div>

          {mounted ? (
            <Row>
              <ApplicationFilter
                allApplications={false}
                handleSearch={initiateSearch}
                turnOffSearch={turnOffSearchMode}
              />
              <Applications
                viewOnly={true}
                user={user}
                data={assigned}
                paginate={paginate}
              />
            </Row>
          ) : null}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Assigned
